/**
 * Recognized PaymentDisplayType type
 * @type {{SCRIPT: string, REDIRECT: string}}
 */
export const PaymentDisplayType = {
    SCRIPT: 'SCRIPT'
    , REDIRECT: 'REDIRECT'
}